import React, { useContext, useEffect } from "react";


import { PanelRoutes } from "./PanelRoutes";
import { routes as authRoutes } from "./AuthRoutes";

import { AuthContext } from "contexts/auth-context";
import { Navigate, Route, Routes, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import RefreshTokenComponent from "component/RefreshTokenComponent";
import { onChangePublic } from "redux/actions/public";
import { useRedux } from "redux/useRedux";
import CompleteModal from "component/completeModal";
import CheckRiskModal from "component/chekRiskModal";



const AppRoutes: React.FunctionComponent = () => {
    const ctx = useContext(AuthContext);
    const location = useLocation();
    const { dispatch, publicState } = useRedux()
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);
    useEffect(() => {
        const product_id = searchParams.get("product_id");
        setTimeout(() => {
            if (product_id) {
                dispatch(onChangePublic("product_id", product_id))
            }
            if (product_id && ctx?.login == "1") navigate(`/basket?product_id=${product_id}`);

        }, 100);

    }, []);

    return (
        <React.Suspense fallback={<div></div>}>

            {ctx?.login == "1" ? (
                <>

                    <RefreshTokenComponent />
                    <CompleteModal/>
                    <CheckRiskModal/>
                    <Routes>
                        {PanelRoutes()?.map((route, index) => {

                            return <Route key={index} path={route.path} element={route.element} />;
                        })}
                        <Route path="*" element={<Navigate to={"/dashboard"} replace />} />
                        {/* <Route path="*" element={<Navigate to={ctx.user?.risk_points !== null ? "/account" : "/risk"} replace />} /> */}
                    </Routes>

                </>
            ) : (
                <>

                    <Routes>
                        {authRoutes?.map((route, index) => {
                            return <Route key={index} path={route.path} element={route.element} />;
                        })}
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </>
            )}


        </React.Suspense>
    );
};

export default AppRoutes;
